import { Injectable } from '@angular/core';
import { PersonRepository } from '@data/repository/person/person.repository';
import { ClienteEntity, CodigoClienteEntity } from '@domain/dto/cliente/cliente-get.dto';
import { ClientePostDto } from '@domain/dto/cliente/cliente-post.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PersonUsecase {
  constructor(private repository: PersonRepository) {}

  getById(id: string, type: string): Observable<ClienteEntity> {
    return this.repository.getById(id, type);
  }
  insert(param: ClientePostDto): Observable<ClientePostDto> {
    return this.repository.insert(param);
  }
  update(param: ClientePostDto): Observable<ClientePostDto> {
    return this.repository.update(param);
  }
  getByCpfOrPass(id: string, type: string): Observable<CodigoClienteEntity> {
    return this.repository.getByCpfOrPass(id, type);
  }
}
